import Precision from "../../../../types/datePrecision";
import dateByAddingSpan from "./dateByAddingSpan";
import dateWithTimestamp from "./dateWithTimestamp";
import { timespanForPrecision } from "./timespanFunctions";

const endDateWithTimestamp = (calendar, timestamp, inPrecision) => {
  const date = dateWithTimestamp(calendar, timestamp, inPrecision);
  // If we have less precision than day, we want to add that unit onto it to go to
  // the end of that period of time.
  if (date.precision <= Precision.Day) {
    return dateByAddingSpan(calendar, date, timespanForPrecision(date.precision));
  }
  return date;
};

export default endDateWithTimestamp;
